module.exports = __webpack_public_path__ + "img/avatiach_no.02221b9c.png";